import axios from "axios";
const axiosFetch = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: process.env.NODE_ENV === "development" ? false : true,
  baseURL: `${
    process.env.NODE_ENV === "development"
      ? "http://localhost:8085"
      : process.env.NODE_ENV === "production"
      ? window.location.origin
      : window.location.origin
  }/api`,
});

export default axiosFetch;
